import "./HotTakeResponses.scss";

import { Avatar, Flex, Text } from "@fluentui/react-northstar";
import { OrdinalQuestion, TeamsSurveyResponse } from "@teams/types";
import { SurveyDTO } from "@teams/types/api";
import moment from "moment";

import { PollyIcon, PollyIconName } from "../../../../../_shared/components/PollyIcon";

type HotTakeResponsesProps = {
  survey: SurveyDTO;
  responses: TeamsSurveyResponse[];
};

export const HotTakeResponses: React.FC<HotTakeResponsesProps> = ({ survey, responses }) => {
  const totalVotes = responses.length;

  return (
    <div className="hot-take-responses">
      <Text content={`Total votes: ${totalVotes}`} weight="semibold" />
      <Flex column gap="gap.small" vAlign="center">
        {responses.map(response => (
          <HotTakeResponseItem key={response.id} survey={survey} response={response} />
        ))}
      </Flex>
    </div>
  );
};

const HotTakeResponseItem: React.FC<{ survey: SurveyDTO; response: TeamsSurveyResponse }> = ({
  survey,
  response,
}) => {
  const hotTakeQuestion = survey.questions[0] as OrdinalQuestion;
  const upVoteChoiceId = hotTakeQuestion.choices[0].id;
  const iconName: PollyIconName =
    response.responses[0].value === upVoteChoiceId ? "thumbs-up-icon" : "thumbs-down-icon";
  const iconColor =
    response.responses[0].value === upVoteChoiceId
      ? "var(--stardustui-categoryColors-green-350)"
      : "var(--stardustui-categoryColors-red-350)";

  return (
    <Flex column gap="gap.smaller" className="hot-take-responses__response-item">
      <div className="hot-take-responses__response-item__header">
        <Flex gap="gap.smaller" vAlign="center">
          <Avatar name={response.user.name || "Anonymous"} size="smallest" />
          <Text content={response.user.name} size="small" />
        </Flex>

        <Text
          content={`${moment.duration(moment().diff(response.createdAt)).humanize()} ago`}
          weight="light"
          size="smaller"
        />
      </div>

      <span style={{ color: iconColor }}>
        <PollyIcon icon={iconName} inheritColor />
      </span>
    </Flex>
  );
};
